// Uses Volto 19's native subpathPrefix for login URL construction
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector, shallowEqual } from 'react-redux';
import config from '@plone/volto/registry';
import { flattenToAppURL, getBaseUrl } from '@plone/volto/helpers/Url/Url';

const Anontools = () => {
  const { settings } = config;
  const token = useSelector((state) => state.userSession.token, shallowEqual);
  const content = useSelector((state) => state.content.data, shallowEqual);
  const pathname = useSelector(
    (state) => state.router.location.pathname,
    shallowEqual,
  );

  const prefix = settings.subpathPrefix || '';
  const contentPath = content?.['@id']
    ? flattenToAppURL(content['@id'])
    : getBaseUrl(pathname);
  const cameFrom = `${prefix}/api${contentPath}`;
  const loginUrl = `${prefix}/login?came_from=${encodeURIComponent(cameFrom)}`;

  return (
    !token && (
      <div className="anontools">
        <a aria-label="login" href={loginUrl}>
          <FormattedMessage id="Log in" defaultMessage="Log in" />
        </a>
      </div>
    )
  );
};

Anontools.propTypes = {
  token: PropTypes.string,
};

export default Anontools;
